import { getWithRedirect, postWithRedirect } from 'utils/axios'
import { TDashboardFilterOption } from 'types/GlobalDashboardFilter'
import { parseQueryParamForPost } from '../Widgets'
import { TGlobalFilterApiInput } from 'types/GlobalGlobalFilter'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/resource-filters`

export async function getAll() {
  return getWithRedirect<TDashboardFilterOption[]>(URL)
}

export async function getOne(
  attributeId: string,
  globalFilter: TGlobalFilterApiInput
) {
  const body = parseQueryParamForPost(null, globalFilter)

  return postWithRedirect<string[]>(`${URL}/${attributeId}`, { data: body })
}
